var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
import DtoConverter from '../core/utils/dto-converter';
import { Translation } from './translation';
import { ProductVariant } from './product-variant';
import { ProductItem } from './product-item';
import { ProductBasePrice } from './product-base-price';
import { ProductAddon } from './product-addon';
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product(data) {
        var _this = _super.call(this, data) || this;
        if (data.translations) {
            _this.translations = DtoConverter.createList(Translation, data.translations);
        }
        if (data.items) {
            _this.items = DtoConverter.createList(ProductItem, data.items);
        }
        if (data.variants) {
            _this.variants = DtoConverter.createList(ProductVariant, data.variants);
        }
        if (data.addons) {
            _this.addons = DtoConverter.createList(ProductAddon, data.addons);
        }
        if (data.base_prices) {
            _this.base_prices = DtoConverter.createList(ProductBasePrice, data.base_prices);
        }
        return _this;
    }
    Product.prototype.getBasePrice = function () {
        var _a, _b;
        if (!((_a = global.App) === null || _a === void 0 ? void 0 : _a.locale.currencyId)) {
            throw new Error('Global locale settings are missing');
        }
        var basePrice = this.base_prices.find(function (item) { return item.currency_id === global.App.locale.currencyId; });
        return (_b = basePrice === null || basePrice === void 0 ? void 0 : basePrice.price) !== null && _b !== void 0 ? _b : 0;
    };
    return Product;
}(Model));
export { Product };
